import { set, isAfter, isBefore, startOfDay } from 'date-fns';

var getDateWithoutTime = function getDateWithoutTime(date) {
  if (date === void 0) {
    date = new Date();
  }

  return set(date, {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  });
};
var isDisabledDate = function isDisabledDate(checkDate, startDate, endDate, focus) {
  return focus === 'startDate' ? !!endDate && isAfter(startOfDay(checkDate), startOfDay(endDate)) : !!startDate && isBefore(startOfDay(checkDate), startOfDay(startDate));
};
var isDisabledTime = function isDisabledTime(checkDate, startDate, endDate, focus) {
  return focus === 'startDate' ? !!endDate && isAfter(checkDate, endDate) : !!startDate && isBefore(checkDate, startDate);
};

export { getDateWithoutTime, isDisabledDate, isDisabledTime };
//# sourceMappingURL=index.esm.js.map
